<template>
  <div class="home-data-table-hub">
    <div class="hub-header">
      <div class="title-box">
        <i class="far fa-list-alt hub-icon"></i>
        <div>
          <h3 class="hub-title">Trung Tâm Dữ Liệu Chi Tiết & Top 5 Bài Nổi Bật</h3>
          <p class="hub-subtitle">
            Báo cáo phân tích chi tiết lượt truy cập GA4 và Top 5 bài nổi bật theo từng chuyên mục du lịch & dịch vụ
          </p>
        </div>
      </div>

      <div class="search-box">
        <el-input
          v-model="searchQuery"
          placeholder="Tìm kiếm nhanh trong bảng..."
          prefix-icon="el-icon-search"
          size="small"
          clearable
          style="width: 260px;"
        ></el-input>
      </div>
    </div>

    <!-- Tabs Container -->
    <div class="hub-tabs-wrapper">
      <el-tabs v-model="activeTab" type="card" class="custom-hub-tabs">
        <!-- Tab 1: GA4 Page Stats -->
        <el-tab-pane name="pages">
          <span slot="label">
            <i class="far fa-file-alt mr-1"></i> Top Trang Truy Cập ({{ filteredPages.length }})
          </span>
          <div class="table-responsive">
            <table class="hub-table">
              <thead>
                <tr>
                  <th style="width: 50px;" class="text-center">STT</th>
                  <th>TIÊU ĐỀ / ĐƯỜNG DẪN TRANG</th>
                  <th style="width: 140px;" class="text-right">LƯỢT XEM</th>
                  <th style="width: 200px;" class="text-right">TỶ TRỌNG (%)</th>
                  <th style="width: 80px;" class="text-center">XEM</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, idx) in filteredPages" :key="idx">
                  <td class="text-center font-bold rank-cell">{{ idx + 1 }}</td>
                  <td>
                    <div class="page-title-box">
                      <span class="page-text font-bold">{{ row.title || row.path }}</span>
                      <span v-if="row.title !== row.path" class="page-subpath">{{ row.path }}</span>
                    </div>
                  </td>
                  <td class="text-right font-bold text-primary">{{ formatNumber(row.views || 0) }}</td>
                  <td class="text-right">
                    <div class="progress-wrap">
                      <div class="progress-bar-bg">
                        <div
                          class="progress-bar-fill fill-blue"
                          :style="{ width: Math.min(row.percentage || 0, 100) + '%' }"
                        ></div>
                      </div>
                      <span class="pct-text">{{ row.percentage || 0 }}%</span>
                    </div>
                  </td>
                  <td class="text-center">
                    <a
                      v-if="row.path && row.path.startsWith('/')"
                      :href="row.path"
                      target="_blank"
                      class="btn-link-ext"
                      title="Mở liên kết"
                    >
                      <i class="fas fa-external-link-alt"></i>
                    </a>
                    <span v-else class="text-muted">---</span>
                  </td>
                </tr>
                <tr v-if="filteredPages.length === 0">
                  <td colspan="5" class="text-center py-4">
                    <el-empty description="Không tìm thấy trang phù hợp"></el-empty>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>

        <!-- Tab 2: GA4 QR Code Scans -->
        <el-tab-pane name="qr">
          <span slot="label">
            <i class="fas fa-qrcode mr-1"></i> Hiệu Quả Quét QR ({{ filteredQr.length }})
          </span>
          <div class="table-responsive">
            <table class="hub-table">
              <thead>
                <tr>
                  <th style="width: 50px;" class="text-center">STT</th>
                  <th>ĐỊA ĐIỂM DU LỊCH / MÃ QUÉT QR</th>
                  <th style="width: 140px;" class="text-right">LƯỢT QUÉT</th>
                  <th style="width: 200px;" class="text-right">TỶ TRỌNG (%)</th>
                  <th style="width: 110px;" class="text-center">TRẠNG THÁI</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, idx) in filteredQr" :key="idx">
                  <td class="text-center font-bold rank-cell">{{ idx + 1 }}</td>
                  <td>
                    <div class="page-title-box">
                      <span class="page-text font-bold">{{ row.title || row.path }}</span>
                      <span v-if="row.title !== row.path" class="page-subpath">{{ row.path }}</span>
                    </div>
                  </td>
                  <td class="text-right font-bold text-pink">{{ formatNumber(row.scans || 0) }}</td>
                  <td class="text-right">
                    <div class="progress-wrap">
                      <div class="progress-bar-bg">
                        <div
                          class="progress-bar-fill fill-pink"
                          :style="{ width: Math.min(row.percentage || 0, 100) + '%' }"
                        ></div>
                      </div>
                      <span class="pct-text">{{ row.percentage || 0 }}%</span>
                    </div>
                  </td>
                  <td class="text-center">
                    <span class="status-badge-active">Hoạt động</span>
                  </td>
                </tr>
                <tr v-if="filteredQr.length === 0">
                  <td colspan="5" class="text-center py-4">
                    <el-empty description="Không có dữ liệu quét mã QR"></el-empty>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>

        <!-- Dynamic Top 5 Tabs for the 7 Featured Modules -->
        <el-tab-pane
          v-for="tab in topRankingTabs"
          :key="tab.key"
          :name="tab.key"
        >
          <span slot="label">
            <i :class="[tab.icon, 'mr-1']"></i> {{ tab.label }} ({{ getFilteredRanking(tab.key).length }})
          </span>
          <div class="table-responsive">
            <table class="hub-table">
              <thead>
                <tr>
                  <th style="width: 60px;" class="text-center">HẠNG</th>
                  <th>{{ tab.nameHeader }}</th>
                  <th style="width: 160px;" class="text-center">DANH MỤC</th>
                  <th v-if="tab.showLocation" style="width: 200px;">ĐỊA ĐIỂM</th>
                  <th style="width: 110px;" class="text-center">ĐÁNH GIÁ</th>
                  <th style="width: 130px;" class="text-right">LƯỢT XEM</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, idx) in getFilteredRanking(tab.key)" :key="row.id || idx">
                  <td class="text-center">
                    <span :class="['rank-badge', `rank-${idx + 1}`]">{{ idx + 1 }}</span>
                  </td>
                  <td class="font-bold text-dark truncate-cell" :title="row.name || row.title">
                    {{ row.name || row.title }}
                  </td>
                  <td class="text-center">
                    <span :class="['tag-category', tab.tagClass]">{{ row.type || tab.defaultType }}</span>
                  </td>
                  <td v-if="tab.showLocation" class="text-muted">
                    {{ row.location || 'Thủ Dầu Một' }}
                  </td>
                  <td class="text-center">
                    <span class="rating-star">⭐ {{ row.rating || '5.0' }}</span>
                  </td>
                  <td class="text-right font-bold text-primary">{{ formatNumber(row.view_count || 0) }}</td>
                </tr>
                <tr v-if="getFilteredRanking(tab.key).length === 0">
                  <td :colspan="tab.showLocation ? 6 : 5" class="text-center py-4">
                    <el-empty :description="`Không có dữ liệu ${tab.label.toLowerCase()}`"></el-empty>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export const TOP_RANKING_TABS = [
  {
    key: 'attraction',
    placeType: 'attraction',
    label: 'Top 5 Danh thắng',
    nameHeader: 'TÊN DANH THẮNG / ĐIỂM ĐẾN',
    defaultType: 'Danh thắng',
    icon: 'fas fa-place-of-worship',
    tagClass: 'tag-blue',
    showLocation: true
  },
  {
    key: 'stay',
    placeType: 'stay',
    label: 'Top 5 Lưu trú',
    nameHeader: 'TÊN CƠ SỞ LƯU TRÚ',
    defaultType: 'Lưu trú',
    icon: 'fas fa-bed',
    tagClass: 'tag-indigo',
    showLocation: true
  },
  {
    key: 'entertainment',
    placeType: 'entertainment',
    label: 'Top 5 Giải trí',
    nameHeader: 'TÊN ĐỊA ĐIỂM GIẢI TRÍ',
    defaultType: 'Giải trí',
    icon: 'fas fa-play-circle',
    tagClass: 'tag-pink',
    showLocation: true
  },
  {
    key: 'cuisine',
    placeType: 'cuisine',
    label: 'Top 5 Ăn uống',
    nameHeader: 'TÊN ĐỊA ĐIỂM ẨM THỰC / ĂN UỐNG',
    defaultType: 'Ăn uống',
    icon: 'fas fa-utensils',
    tagClass: 'tag-orange',
    showLocation: true
  },
  {
    key: 'tour',
    placeType: 'tour',
    label: 'Top 5 Tour',
    nameHeader: 'TÊN CHƯƠNG TRÌNH TOUR DU LỊCH',
    defaultType: 'Tour du lịch',
    icon: 'fas fa-route',
    tagClass: 'tag-teal',
    showLocation: false
  },
  {
    key: 'post',
    placeType: 'post',
    label: 'Top 5 Tin tức',
    nameHeader: 'TIÊU ĐỀ BÀI VIẾT / TIN TỨC',
    defaultType: 'Tin tức & Chia sẻ',
    icon: 'far fa-newspaper',
    tagClass: 'tag-green',
    showLocation: false
  },
  {
    key: 'travelExperience',
    placeType: 'travel-experience',
    label: 'Top 5 Kinh nghiệm du lịch',
    nameHeader: 'TIÊU ĐỀ BÀI KINH NGHIỆM DU LỊCH',
    defaultType: 'Kinh nghiệm du lịch',
    icon: 'fas fa-suitcase-rolling',
    tagClass: 'tag-purple',
    showLocation: false
  }
]

export default {
  name: 'HomeDataTableHub',
  props: {
    pageStats: {
      type: Array,
      default: () => []
    },
    qrStats: {
      type: Array,
      default: () => []
    },
    topRankings: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      activeTab: 'attraction',
      searchQuery: '',
      topRankingTabs: TOP_RANKING_TABS
    }
  },
  computed: {
    filteredPages() {
      if (!this.searchQuery) return this.pageStats
      const q = this.searchQuery.toLowerCase()
      return this.pageStats.filter(
        (p) => (p.title && p.title.toLowerCase().includes(q)) || (p.path && p.path.toLowerCase().includes(q))
      )
    },
    filteredQr() {
      if (!this.searchQuery) return this.qrStats
      const q = this.searchQuery.toLowerCase()
      return this.qrStats.filter(
        (p) => (p.title && p.title.toLowerCase().includes(q)) || (p.path && p.path.toLowerCase().includes(q))
      )
    }
  },
  methods: {
    getFilteredRanking(key) {
      const list = (this.topRankings && this.topRankings[key]) || []
      if (!this.searchQuery) return list
      const q = this.searchQuery.toLowerCase()
      return list.filter(
        (item) =>
          (item.name && item.name.toLowerCase().includes(q)) ||
          (item.title && item.title.toLowerCase().includes(q)) ||
          (item.type && item.type.toLowerCase().includes(q)) ||
          (item.location && item.location.toLowerCase().includes(q))
      )
    },
    formatNumber(num) {
      if (num === undefined || num === null) return '0'
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  }
}
</script>

<style lang="scss" scoped>
.home-data-table-hub {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.03);
  padding: 20px;
  margin-bottom: 24px;

  .hub-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    flex-wrap: wrap;
    gap: 12px;

    .title-box {
      display: flex;
      align-items: center;
      gap: 10px;

      .hub-icon {
        font-size: 20px;
        color: #8b5cf6;
      }

      .hub-title {
        margin: 0;
        font-size: 16px;
        font-weight: 800;
        color: #1e293b;
      }

      .hub-subtitle {
        margin: 3px 0 0 0;
        font-size: 12.5px;
        color: #64748b;
        font-weight: 500;
      }
    }
  }

  .custom-hub-tabs {
    ::v-deep .el-tabs__header {
      margin-bottom: 16px;
      border-bottom: 1px solid #e2e8f0;
    }

    ::v-deep .el-tabs__item {
      font-size: 13px;
      font-weight: 700;
      color: #64748b;
      padding: 0 14px;
      height: 38px;
      line-height: 38px;

      &.is-active {
        color: #8b5cf6;
        background: #f5f3ff;
        border-color: #e2e8f0;
        border-bottom-color: #ffffff;
      }
    }
  }

  .table-responsive {
    overflow-x: auto;
  }

  .hub-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;

    th {
      background: #f8fafc;
      color: #475569;
      font-weight: 700;
      font-size: 11.5px;
      text-transform: uppercase;
      letter-spacing: 0.3px;
      padding: 12px 14px;
      border-bottom: 2px solid #e2e8f0;
    }

    td {
      padding: 12px 14px;
      border-bottom: 1px solid #f1f5f9;
      color: #334155;
    }

    tr:hover td {
      background-color: #f8fafc;
    }

    .font-bold {
      font-weight: 700;
    }

    .text-center { text-align: center; }
    .text-right { text-align: right; }
    .text-primary { color: #2563eb; }
    .text-pink { color: #db2777; }
    .text-dark { color: #0f172a; }
    .text-muted { color: #94a3b8; }

    .page-title-box {
      display: flex;
      flex-direction: column;

      .page-text {
        font-size: 13px;
        color: #1e293b;
      }

      .page-subpath {
        font-size: 11.5px;
        color: #94a3b8;
        margin-top: 2px;
      }
    }

    .truncate-cell {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 380px;
    }

    .rank-cell {
      color: #64748b;
    }

    .rank-badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      border-radius: 6px;
      font-size: 11.5px;
      font-weight: 800;

      &.rank-1 { background: #fef3c7; color: #b45309; border: 1px solid #fde68a; }
      &.rank-2 { background: #f1f5f9; color: #475569; border: 1px solid #e2e8f0; }
      &.rank-3 { background: #ffedd5; color: #c2410c; border: 1px solid #fed7aa; }
      &.rank-4, &.rank-5 { background: #ffffff; color: #64748b; border: 1px solid #e2e8f0; }
    }

    .tag-category {
      font-size: 11px;
      font-weight: 700;
      padding: 3px 8px;
      border-radius: 4px;
      display: inline-block;

      &.tag-purple { background: #f3e8ff; color: #7e22ce; }
      &.tag-blue { background: #e0f2fe; color: #0369a1; }
      &.tag-indigo { background: #e0e7ff; color: #4338ca; }
      &.tag-pink { background: #fce7f3; color: #be185d; }
      &.tag-orange { background: #ffedd5; color: #c2410c; }
      &.tag-teal { background: #ccfbf1; color: #0f766e; }
      &.tag-green { background: #dcfce7; color: #15803d; }
    }

    .rating-star {
      background: #fffbeb;
      color: #b45309;
      border: 1px solid #fde68a;
      padding: 2px 6px;
      border-radius: 4px;
      font-size: 11.5px;
      font-weight: 700;
    }

    .status-badge-active {
      background: #ecfdf5;
      color: #059669;
      font-size: 11px;
      font-weight: 700;
      padding: 2px 8px;
      border-radius: 12px;
      border: 1px solid #a7f3d0;
    }

    .btn-link-ext {
      color: #64748b;
      font-size: 13px;
      &:hover {
        color: #2563eb;
      }
    }

    .progress-wrap {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 8px;

      .progress-bar-bg {
        width: 100px;
        height: 6px;
        background-color: #f1f5f9;
        border-radius: 3px;
        overflow: hidden;

        .progress-bar-fill {
          height: 100%;
          border-radius: 3px;

          &.fill-blue { background-color: #3b82f6; }
          &.fill-pink { background-color: #ec4899; }
        }
      }

      .pct-text {
        font-size: 12px;
        font-weight: 700;
        color: #475569;
        min-width: 42px;
        text-align: right;
      }
    }
  }
}
</style>
